import { render, staticRenderFns } from "./MimdgGrid.vue?vue&type=template&id=18b79007"
import script from "./MimdgGrid.vue?vue&type=script&lang=js"
export * from "./MimdgGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports